/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Content from './Content/index'
import Editor from 'DesignSystem/Editor/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/PreviewDocumentModal/Content/Content/HtmlFile/Content"
  
}) {
  return (<React.Fragment
>
<Editor
  viewPath={`${viewPath}/Editor`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</Editor>
{children}
</React.Fragment>)
}